// src/utils/constants.ts
export const CONSTANTS = {
    MAX_RECONNECT_ATTEMPTS: 5,
    WS_RECONNECT_DELAY: 3000,
    PING_INTERVAL: 30000,
    AUDIO_LOAD_TIMEOUT: 10000,
    MAX_MESSAGE_HISTORY: 100,
    RECONNECT_DELAY: 3000,
    HEARTBEAT_INTERVAL: 30000,
    SESSION_TIMEOUT: 300000, // 5分钟会话超时
};

const pageWsProtocol =
    typeof window !== "undefined" && window.location.protocol === "https:"
        ? "wss:"
        : "ws:";

export const WS_CONFIG = {
    URL:
        import.meta.env.VITE_WS_URL ||
        `${pageWsProtocol}//${window.location.host}/api/ws`,
    RECONNECT_ATTEMPTS: 5,
    RECONNECT_DELAY: 3000,
    HEARTBEAT_INTERVAL: 30000,
};

/** 数字人 WebRTC 信令 URL
 * 测试环境: ws://localhost:3000/ws (vite proxy → :9000)
 * 生产环境: 通过 VITE_AVATAR_WS_URL 或随页面走 wss://{host}/avatar/ws
 */
export const AVATAR_WS_CONFIG = {
    URL:
        import.meta.env.VITE_AVATAR_WS_URL ||
        `${pageWsProtocol}//${window.location.host}/avatar/ws`,
};

export const AUDIO_CONFIG = {
    SAMPLE_RATE: 16000,
    CHANNELS: 1,
    BIT_DEPTH: 16,
    FORMAT: "pcm" as const,
};

/**
 * 数字人 HTTP（/new_session）。
 * 本地开发走当前页面的 /api，由 Vite 转到 ugv-chat-server:8086。
 * 线上未配置时仍用站点域名。
 */
export const AVATAR_HTTP_CONFIG = {
    URL:
        import.meta.env.VITE_AVATAR_BASE_URL ||
        (import.meta.env.DEV ? "/api" : "https://chat.ikunqi.cn/api"),
};

/** 语音端点检测 */
export const VAD_CONFIG = {
    /** 略降门槛，弱麦 / WSL 虚拟声卡也能开口 */
    SPEECH_THRESHOLD: 0.022,
    SILENCE_THRESHOLD: 0.012,
    /** 停顿多久视为说完（过短易把句中换气切成空包） */
    SILENCE_DURATION_MS: 900,
    /** 短于此时长的拾音当作噪声丢掉 */
    MIN_SPEECH_MS: 350,
    /** 开口前保留的前置音频，避免吃字 */
    PREROLL_MS: 400,
    /** 数字人说完后再等一会才倾听，避免把尾音当用户说话 */
    RESUME_GUARD_MS: 550,
    /** 恢复倾听时最多保留的尾音，避免守卫期内用户抢话被 drain 掉 */
    RESUME_KEEP_MS: 2000,
};

/** TTS 推流：44.1k s16 PCM，与后端 NLS 合成采样率一致 */
export const TTS_TAIL_CONFIG = {
    /** 句尾补静音，给 SDK 收口 */
    SILENCE_MS: 320,
    /** 句首留很短的静音，避免数字人起播时把第一个字念断 */
    HEAD_SILENCE_MS: 80,
    /** onPlaybackEnd 未到时的兜底释放余量 */
    FINISH_EXTRA_MS: 1000,
    /** 与 VAD 恢复守卫对齐，兜底定时器一并计入 */
    RESUME_GUARD_MS: 450,
    SAMPLE_RATE: 44100,
    /** 先攒约 450ms 再开口，既不等整句合成完，也不让前几个字卡断 */
    PREBUFFER_SAMPLES: 19845,
    /** 分片到达后短暂合并再推 */
    FLUSH_DEBOUNCE_MS: 24,
    /** 向数字人匀速喂流，避免瞬时灌入过多或中间断流 */
    PUMP_SAMPLES: 4096,
    PUMP_INTERVAL_MS: 70,
    PENDING_MAX_BYTES: 8 * 1024 * 1024,
};
